// extracted by mini-css-extract-plugin
export var container = "_ak-0";
export var containerTopRight = "_ak-1";